export default __webpack_public_path__ + "static/media/error_img.cea2da40.png";